const IDLE_TIMEOUT_MS = 2000;
const NO_IDLE_API_DELAY_MS = 1500;

/**
 * Runs `task` once the browser is idle so vendor analytics stay off the first
 * paint, or after a bounded wait on a busy page. Safari has no
 * requestIdleCallback and gets a plain delay.
 *
 * Leaving the page runs it straight away: the provider queues only drain once
 * the vendor script is in, so that is the last chance for a short visit to
 * report anything.
 */
export const whenIdle = (task: () => void) => {
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    window.removeEventListener("pagehide", run);
    document.removeEventListener("visibilitychange", runIfHidden);
    task();
  };
  const runIfHidden = () => {
    if (document.visibilityState === "hidden") run();
  };

  window.addEventListener("pagehide", run);
  document.addEventListener("visibilitychange", runIfHidden);

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: IDLE_TIMEOUT_MS });
  } else {
    window.setTimeout(run, NO_IDLE_API_DELAY_MS);
  }
};
